import { Reveal, Eyebrow } from "./Reveal";

export default function WhyWeBuilt() {
  return (
    <section className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="why-we-built-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow number="03" label="Why We Built Romii" />
              <h2 className="text-3xl sm:text-4xl font-light tracking-tight text-[#111827]">
                Not about <span className="font-serif-italic text-[#E89A4D]">technology.</span>
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <Reveal delay={0.1}>
              <div className="space-y-8">
                <p className="text-2xl md:text-3xl font-light leading-snug text-[#111827]">
                  Seeing Alzheimer's and Dementia within our own family{" "}
                  <span className="font-serif-italic">changed how we viewed care.</span>
                </p>
                <div className="space-y-5 text-gray-500 leading-relaxed text-base md:text-lg max-w-xl">
                  <p>
                    We realized that beyond medicine, people often need reassurance, familiarity,
                    and the confidence that someone is quietly there for them.
                  </p>
                  <p className="text-[#111827] font-medium">Romii was born from that realization.</p>
                  <p>
                    Our goal isn't to replace caregivers. It's to support the moments where
                    technology can gently preserve dignity, independence, and connection.
                  </p>
                </div>
                <div className="h-1 w-16 rounded-full bg-[#E89A4D]/60" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
